<template>
	<div ref="lmy-home-page" class="lmy-home-page">
		<div class="lmy-content">
        <div class="lmy-content-a lmy-banner">
            <Swipe v-if="!bannerList||bannerList.length<=0" :auto="6000">
                <SwipeItem>
                    <img src="./../assets/img/banner/1.jpg"  class="swipe-imgs" style="width:100%;height:3.5rem" />
                </SwipeItem>
            </Swipe>
            <Swipe v-if="bannerList&&bannerList.length>0" :auto="6000">
                <SwipeItem  v-for="img in bannerList" :key="img.Name" :auto="6000" >
                    <img :src="('/'+img.Img)|replaceImgSrc(100)" :alt="img.Name" class="swipe-imgs" style="width:100%;height:3.5rem"  @click="routerToHotel(img,true)"/>
                </SwipeItem>
            </Swipe>
        </div>
        <div ref="fixLi" :class="FixedLi?'top-nav lmy-nav':'lmy-nav'">
            <div  :class="productTypeActive == 'Hotel'?'nav-item active':'nav-item'" @click="productTypeActive = 'Hotel';toTopPlace()">酒店</div>
            <div  :class="productTypeActive == 'Package'?'nav-item active':'nav-item'" @click="productTypeActive = 'Package';toTopPlace()">度假</div>
            <!-- <div  :class="productTypeActive == 'Ticket'?'nav-item active':'nav-item'" @click="productTypeActive = 'Ticket';toTopPlace()">门票</div> -->
            <div  :class="productTypeActive == 'Meeting'?'nav-item active':'nav-item'" @click="productTypeActive = 'Meeting';toTopPlace()">会议</div>
            <!-- <div  class="activityTab" :class="productTypeActive == 'Activity'?'nav-item active':'nav-item'" @click="productTypeActive = 'Activity';toTopPlace()">抢购</div> -->
        </div>
        <!-- <div class="placeholder" v-if="FixedLi"></div> -->

        <!-- 酒店查询 -->
        <div v-if="productTypeActive == 'Hotel'">
          <div class="lmy-content-b">
            <div class="select-box">
              <ul class="select-list">
                <li class="list-item" @click="cityData.show=true">
                    <!-- <i class="list-icon iconfont icon-lmy-chengshi list-icon"></i> -->
                    <div class="list-content city-content">
                        <p class="choose-city">国内/海外目的地</p>
                        <p class="choose-city" v-if="isLoadingPosition" >
                            <span class="loader" ></span>定位中...
                        </p>
                        <p  class="city" v-if="!isLoadingPosition">
                            {{LocationName||CityName}}
                        </p>
                    </div>
                    <i class="iconfont icon-arrow"></i>
                </li>
                <li class="list-item" @click="dateSelect()">
                    <!-- <i class="list-icon iconfont icon-calendar list-icon"></i> -->
                    <div class="list-content date-content">
                        <div>
                            <span>{{CheckIn | dateWeek}} 入住</span><br/>
                            <span class="date">{{CheckIn|dateToYMDline}}</span>
                        </div>
                        <div><span class="total-day">{{getDays(CheckIn,CheckOut)}}晚</span></div>
                        <div>
                            <span>{{CheckOut | dateWeek}} 离店</span><br/>
                            <span class="date">{{CheckOut|dateToYMDline}}</span>
                        </div>

                    </div>
                    <i class="iconfont icon-arrow"></i>
                </li>
                <li class="list-item" @click="rpData.show=true" v-if="From==0">
                  <!-- <i class="iconfont icon-my list-icon"></i> -->
                  <div class="list-item-dv">
                    <div class="list-content city-content lidv1">
                      <p class="choose-city">间数</p>
                      <p>{{RoomCount}}</p>
                    </div>
                    <div class="list-content city-content lidv2">
                      <p class="choose-city">每间成人数</p>
                      <p>{{AdultCount}}</p>
                    </div>
                    <div class="list-content city-content lidv2">
                      <p class="choose-city">每间儿童数</p>
                      <p>{{ChildrenCount}}</p>
                    </div>
                  </div>

                  <!-- <i class="iconfont icon-more"></i> -->
                </li>
                <li class="list-item" @click='hotelData.show=true'>
                  <!-- <i class="list-icon iconfont icon-hotel"></i> -->
                  <div class="list-content noneHeight" v-if="!Landmark&&!Name">行政区/商圈/关键词/酒店</div>
                  <div class="list-content noneHeight active" v-if="Landmark||Name">{{Landmark||Name}}</div>
                  <i class="iconfont icon-close" @click="clearLandmark($event)" v-if="Landmark||Name"></i>
                  <i class="iconfont icon-arrow"></i>
                </li>
                <li class="list-item" @click="starData.show=true">
                  <!-- <i class="list-icon iconfont icon-lmy-qian list-icon"></i> -->
                  <div class="list-content noneHeight" v-if="!PriceName&&!StarName">价格/星级</div>
                  <div class="list-content noneHeight active" v-if="PriceName||Star">{{PriceName+StarName}}</div>

                  <i class="iconfont icon-close" @click="clearPriceAndStar($event)" v-if="PriceName||Star"></i>
                  <i class="iconfont icon-arrow"></i>
                </li>
              </ul>

              <div class="lmy-btn search-btn" @click="submit" v-if="From==1">
                <i class="iconfont icon-iconfont-seach"></i>查询酒店
              </div>

              <div class="lmy-btn search-btn" @click="frSubmit" v-if="From==0">
                <i class="iconfont icon-iconfont-seach"></i>查询酒店
              </div>

            </div>
          </div>

            <div class="lmy-banner min-banner">
                <Swipe :auto="5000">
                    <SwipeItem v-for="img in bannerPresaleList" :key="img.Name" :auto="5000"  >
                        <img :src="('/'+img.Img)|replaceImgSrc(100)"  class="swipe-imgs" style="width:100%;height:1.76rem"   @click="toPresaleDetail(img.ProductID,img)"  />
                    </SwipeItem>

                </Swipe>
            </div>



          <div class="lmy-content-c">
            <p class="hotTitle">热门目的地</p>
            <div class="address-tab" v-show="cnhotCityHotelsList">
              <div :class="hotFrom==1?'tab-item active':'tab-item' " @click="hotFrom=1">国内</div>
              <div :class="hotFrom==0?'tab-item active':'tab-item' "  @click="hotFrom=0">海外</div>
            </div>
            <!-- 国内 -->
            <div v-if="hotFrom==1&&cnhotCityHotelsList">
              <div class="hotel-box">
              <ul class="address-list" :style="!cnHotUlActive?'height:.6rem':'','width:'+(cnhotCityHotelsList.length * 1.24)+'rem'">
                <li :class="item.active?'list-item active':'list-item'" v-for="item in cnhotCityHotelsList" @click="getHotCityHotelsInfoList(item,1)">{{item.key}}</li>

              </ul>
            </div>

              <div class="hotel-hot-list">

                <div v-if="isHotCityLoading">
                </div>
                <div class="hotel-list " v-for="list in cnhotCityHotelsList" v-if="!isHotCityLoading&&list&&list.list&&list.active">
                  <div class="list-item" v-if="isHotCityLoading"></div>
                  <div class="list-item" v-for="hotel in list.list" v-if="list.active" @click="routeToDetails(hotel,1)">
                    <div class="hotel-img">
                      <p>龙猫精选</p>
                      <img :src="hotel.Pics[0].Url|replaceImgSrc(4)" v-if="hotel.Pics&&hotel.Pics[0]" alt="">
                      <img src="./../assets/img/hotelDetailsDf.png" v-if="!hotel.Pics||!hotel.Pics[0]||hotel.Pics[0].Url=='/'" alt="">
                    </div>
                    <div class="hotel-content">
                      <h5 class="title">{{hotel.HotelName}}</h5>
                      <label class="hotel-label">{{hotel.CommRate}}分</label>&nbsp;<label class="hotel-label">{{hotel.Evaluation}}&nbsp;|&nbsp;{{hotel.DistrictName}}&nbsp;{{hotel.Landmark}}</label>
                      <div class="price"><span class="one">￥{{hotel.LowestPrice}}</span> 起</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 海外 -->
            <div v-if="hotFrom==0&&frhotCityHotelsList">
                <div class="hotel-box">
                    <ul class="address-list" :style="!frHotUlActive?'height:.6rem':'','width:'+(frhotCityHotelsList.length * 1.24 +1.24)+'rem'">
                        <li :class="item.active?'list-item active':'list-item'" v-for="item in frhotCityHotelsList" @click="getHotCityHotelsInfoList(item,0)">{{item.key}}</li>
                    </ul>
                </div>
              <div class="hotel-box hotel-hot-list">

                <div v-if="isHotCityLoading">
                  <div class="infinite-loading-containers" >
                    <i class="loading-defaults"></i>
                  </div>
                </div>
                <ul class="hotel-list " v-for="list in frhotCityHotelsList" v-if="!isHotCityLoading&&list&&list.list&&list.active">
                  <li class="list-item" v-for="hotel in list.list" v-if="list.active" @click="routeToDetails(hotel,0)">
                    <div class="hotel-img">
                      <p>龙猫精选</p>
                      <img :src="hotel.Pics[0].Url|replaceImgSrc(8)" v-if="hotel.Pics&&hotel.Pics[0]" alt="">
                      <img src="./../assets/img/hotelDetailsDf.png" v-if="!hotel.Pics||!hotel.Pics[0]||hotel.Pics[0].Url=='/'" alt="">
                    </div>
                    <div class="hotel-content">
                      <h5 class="title">{{hotel.HotelName}}</h5>
                      <label class="hotel-label">{{hotel.LocationCN}}</label>
                      <div class="price" v-if="hotel.LowestPrice"><span class="one">￥{{hotel.LowestPrice}}</span>起</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
          <ul class="home-holte-bottom">
              <li v-if="hotFrom==1"  @click="submit('more')">更多酒店 <i class="iconfont icon-more" ></i></li>
              <li v-else-if="hotFrom==0"  @click="frSubmit('more')">更多酒店 <i class="iconfont icon-more"></i></li>
              <li @click="toTopPlace">返回顶部 <i class="iconfont icon-more"></i></li>
          </ul>
        </div>

        <!-- 自由行 、度假-->
        <div v-if="productTypeActive == 'Package'">
            <div class="lmy-content-b">
                <div class="select-box">
                    <ul class="select-list">
                        <li class="list-item" @click="packageCityData.show=true">
                            <!-- <i class="list-icon iconfont icon-lmy-chengshi list-icon"></i> -->
                            <div class="list-content city-content">
                                <p class="choose-city">热门目的地</p>
                                <p  class="city" >
                                    {{packageCityData.PackageCityName}}
                                </p>
                            </div>
                            <i class="iconfont icon-arrow"></i>
                        </li>
                        <!-- <li class="list-item">
                            <div class="list-content query-item-box"  @click="controlSelectPage(true,'类型',SubType.value)">
                                <p class="query-item-title">选择类型</p>
                                <p>{{SubType.lable}}</p>
                            </div>
                        </li> -->
                        <li class="list-item">
                            <div class="list-content noneHeight">
                                <input type="text" v-model="PackageKeyword" placeholder="请输入关键字">

                            </div>
                            <i class="iconfont icon-close" @click="clearPackageKeyword($event)" v-if="PackageKeyword"></i>
                        </li>
                    </ul>
                    <div class="lmy-btn search-btn" @click="routeToPackageList">
                        <i class="iconfont icon-iconfont-seach"></i>查询
                    </div>
                </div>
            </div>
            <div class="lmy-flash lmy-flash-div">
                <p class="hotTitle">热门推荐</p>
                <div class="flash-content" v-for="item in packageList" @click="$router.push('/packageDetails?ProductId='+item.ProductId);">
                    <div class="flash-figure">
                        <div class="bannerTag">
                            <p class="red" v-if="item.Type==1">优惠度假</p>
                            <p class="orange" v-else>超值预售</p>
                        </div>
                        <img class="product-img" v-if="item.ListImg" :src="item.ListImg | replaceImgSrc(4)" @error='imgEro(item)' alt="">
                        <img class="product-img" v-else src="../assets/img/hotelDetailsDf.png" alt="">
                        <div class="icon" v-show="item.CityName">
                            <i class="iconfont icon-lmy-dingwei" ></i>
                            {{item.CityName}}
                        </div>
                    </div>
                    <div class="price">
                        <div class="text">
                        ￥<span class="number">{{item.Price||' XX '}}</span> 起
                        </div>
                        <div class="time" v-if="(dateIntervene(item.SaleStart)<=0)&&item.clockHour&&(item.clockHour<48)">
                            <span class="on" v-if="item.clockEnd">距结束 :</span>
                            <span class="under" v-html="item.clockEnd"></span>
                        </div>
                        <div class="time" v-if="dateIntervene(item.SaleStart)>0">
                            <p class="on" v-if="item.clockStart">距开售 :</p>
                            <p class="under" v-html="item.clockStart"></p>
                        </div>
                    </div>
                    <div class="flash-sum">
                        <div class="info">
                            <p>{{item.ProductName}}</p>
                            <div class="box" v-if="item.Tags&&item.Tags.length>0"><div class="PackageTag">{{item.Tags[0]}}</div></div>
                        <!-- <div class="tag">{{item.Tags[0]}}</div> -->
                        <!-- <span class="flash-sum-tags">{{item.SubType}}</span> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center"  v-if="!packageList">
                <span>暂无产品</span>
            </div>
            <ul class="home-holte-bottom">
                <li  @click="$router.push('/packageList')">查看更多 <i class="iconfont icon-more" ></i></li>
            </ul>
        </div>


        <!-- 门票  -->
        <div v-if="productTypeActive == 'Ticket'">
          <div class="lmy-content-b">
              <div class="select-box">
                  <ul class="select-list">
                        <li class="list-item" @click="cityData.show=true">
                            <!-- <i class="list-icon iconfont icon-lmy-chengshi list-icon"></i> -->
                            <div class="list-content city-content">
                                <p class="choose-city">国内/海外目的地</p>
                                <p class="choose-city" v-if="isLoadingPosition" >
                                    <span class="loader" ></span>定位中...
                                </p>
                                <p  class="city" v-if="!isLoadingPosition">
                                    {{LocationName||CityName}}
                                </p>
                            </div>
                            <i class="iconfont icon-arrow"></i>
                        </li>
                        <li class="list-item">
                            <div class="list-content noneHeight">
                                <input type="text" v-model="ticketName" placeholder="请输入关键字">
                            </div>
                            <i class="iconfont icon-close" @click="clearTicketKeyword($event)" v-if="ticketName"></i>
                        </li>
                    </ul>
                    <div class="lmy-btn search-btn" @click="routeToTicketList">
                        <i class="iconfont icon-iconfont-seach"></i>查询
                    </div>
              </div>
          </div>
          <div class="lmy-flash lmy-flash-div">
                <p class="hotTitle">热门推荐</p>
                <div class="flash-content" v-for="tk in ticketList" @click="$router.push('/ticketDetails?ProductID='+tk.ProductID+'&SupFlag='+tk.SupFlag);">
                    <div class="flash-figure">
                        <p>龙猫门票</p>
                        <img class="product-img" :src="tk.ListImg|replaceImgSrc(4)" v-if="tk.ListImg&&tk.ListImg!='/'" alt="" >
                        <img class="product-img" src="./../assets/img/default-hotel.jpg" v-else alt="" >
                    </div>
                    <div class="flash-sum-a">
                        <div class="info holidayInfo">
                            <p>{{tk.ProductName}}</p>
                            <span v-show="tk.CNCityName" class="ticket-tags">{{tk.CNCityName}}</span>
                            <!-- <p class="distance">
                                <span v-if="tk.ScenicLevel">{{tk.ScenicLevel}}A景区&nbsp;</span>
                                <span v-if="tk.Distance">{{tk.Distance}}</span>
                            </p> -->
                            <div class="ticket-price" v-if="tk.Price"><span class="money">￥{{tk.Price}}</span> 起</div>
                        </div>
                  </div>
                </div>
            </div>
            <ul class="home-holte-bottom">
                <li  @click="$router.push('/ticketList')">查看更多 <i class="iconfont icon-more" ></i></li>
            </ul>
        </div>
        <!-- 会议 -->
        <div v-show="productTypeActive == 'Meeting'">
            <div class="lmy-content-b">
                <div class="select-box">
                    <ul class="select-list">
                        <li class="list-item">
                            <div class="list-content query-item-box"  @click="controlSelectPage(true,'活动城市',meetCity.value)">
                                <p class="query-item-title">活动城市</p>
                                <p>
                                    {{meetCity.lable}}
                                </p>
                            </div>
                        </li>
                        <li class="list-item meet-message" >
                            <div class="list-content query-item-box" @click="meetTime()">
                                <p class="query-item-title">举办时间</p>
                                <p>
                                    <span class="date">{{meetingDate|dateToYMDline}}</span>
                                </p>
                            </div>
                            <div class="parting-line"></div>
                            <div class="list-content query-item-box con-right"  @click="controlSelectPage(true,'活动人数',persionNumData.value)">
                                <p class="query-item-title">活动人数</p>
                                <p>{{persionNumData.lable}}</p>
                            </div>
                        </li>
                        <li class="list-item meet-message" >
                            <div class="list-content query-item-box" @click="controlSelectPage(true,'活动预算',meetPriceData.value)">
                                <p class="query-item-title">活动预算</p>
                                <p>{{meetPriceData.lable}}</p>
                            </div>
                            <div class="parting-line" ></div>
                            <div class="list-content query-item-box con-right" @click="controlSelectPage(true,'活动类型',meetTypeData.value)">
                                <p class="query-item-title">活动类型</p>
                                <p>{{meetTypeData.lable}}</p>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-content query-item-box" @click="controlSelectPage(true,'活动需求',meetNeed.value)">
                                <p class="query-item-title">活动需求</p>
                                <p>{{meetNeed.lable}}</p>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-content noneHeight">
                                <!-- <p class="query-item-title">联系电话</p> -->
                                <input class="phoneNum" type="text" v-model="phoneNumber" placeholder="请输入联系电话">
                            </div>
                        </li>
                    </ul>
                    <div class="lmy-btn search-btn" @click="meetingQueryVerify">
                        <i class="iconfont icon-iconfont-seach"></i>提交
                    </div>
                </div>
            </div>
        </div>

        <!-- 抢购，预售 -->
        <div v-if="productTypeActive == 'Activity'">
			<!-- <div class="open-book">
            	<p><i class="iconfont icon-tixing1"></i>海量超值产品不断更新中，总有一款适合你</p>
        	</div> -->
            <!-- <div class="groupsbox">
              <ul class="groupsbox-list" :style="'width:'+(activeGroups.length * 1.8)+'rem'">
                <li :class="activeGroupsItem==item.value?'list-item active':'list-item'" v-for="item in activeGroups" :key="item.value" @click="activeGroupsFoo(item)">{{item.lable}}</li>

              </ul>
            </div> -->
            <div class="lmy-new-search">
              <div class="search-box">
                  <div class="input-box">
                      <input type="text" v-model="presaleName" placeholder="请输入搜索关键字">
                  </div>
                  <span class="search-btn" @click="$router.push('/presaleList?key='+presaleName)">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-sousuo"></use>
                    </svg>
                  </span>
              </div>
            </div>
            <div class="lmy-flash lmy-flash-div">
                <div class="infinite-loading-containers" v-show="presaleList&&presaleList.length==0">
                  <i class="loading-defaults"></i>
                </div>
                <div class="flash-content" v-for="item in presaleList" @click="$router.push('/presaleDetails?id='+item.ID);">
                    <div class="flash-figure">
                        <p>{{item.City}}</p>
                        <!-- <p class="high-Rebate-price" v-if="item.Rebate">立即返佣￥{{item.Rebate}}</p> -->
                        <img class="product-img" v-if="item.Img" :src="item.Img | replaceImgSrc(12)" alt="">
	                    <img class="product-img" v-else src="./../assets/img/hotelDetailsDf.png" alt=""> 
                    </div>

                     <div class="flash-sum-a">
                         <div class="only">
                            <div>
                                <p class="newPrice">￥{{item.SalePrice}}</p>
                                <!-- <p class="oldPrice">市场价￥{{item.MarketPrice}}</p> -->
                            </div>
                            <div v-if="dateIntervene(item.Start)<=0">
                                <span class="on">距结束:</span>
                                <span class="under" v-html="item.clockEnd"></span>
                            </div>
                            <div v-if="dateIntervene(item.Start)>0">
                                <p class="on">距开始:</p>
                                <p class="under" v-html="item.clockStart"></p>
                            </div>
                        </div>
                        <div class="info">
                            <p class="title">{{item.Name}}</p>
                        </div>

                     </div>

                </div>
            </div>
            <div class="text-center"  v-if="!presaleList">
                <img src="./../assets/img/kongzhuang.jpg" alt="" />

            </div>
            <ul class="home-holte-bottom">
                <li  v-if="presaleList" @click="$router.push('/presaleList?key='+presaleName)">查看更多 <i class="iconfont icon-more" ></i></li>
            </ul>
        </div>

        <!-- <div class="is-user-follow-box" v-if="isUserFollowed" >
            <img src="./../assets/img/follow1.png" v-if="isFollowBefore" @click="isFollowBefore=false"/>
            <img src="./../assets/img/follow2.png" v-if="!isFollowBefore"/>

        </div> -->

    </div>
    <transition  name="slide" >
        <DatePicker @select="calendar.select" :beginText="isDateSelectOneOnly?'':'入住'" :meetingDate="calendar.meetingDate"
        :isDateSelectOneOnly="isDateSelectOneOnly" :start="calendar.start" :last="calendar.last"
        :beginDate="calendar.begin" :endDate="calendar.end" :monthLength="calendar.monthLength"
        v-show="calendar.show" ></DatePicker>
    </transition>
    <transition  name="slide" >
        <City @select="cityData.select" @reSetLocation="cityData.reSetLocation" :cityData="cityData"  v-show="cityData.show" ></City>
    </transition>
    <transition  name="slide" >
        <PackageCity @select="packageCityData.select" @cancel='packageCityData.cancel' :cityData="cityData" v-show="packageCityData.show"></PackageCity>
    </transition>
    <transition  name="slide" >
        <HotPlace @select="hotelData.select"  @landmark="hotelData.landmark" :hotelData="hotelData" :from="From" :RegionID="RegionID"  v-show="hotelData.show" ></HotPlace>
    </transition>
    <!-- 活动人数 -->
    <transition  name="slide" >
        <selectPage v-if="selectPageType.show" :title="selectPageType.type" :active="selectPageType.active" @getSelectData="getSelectData" @showPage="controlSelectPage"></selectPage>
    </transition>
    <Star @selectStar="starData.selectStar"  @selectPrice="starData.selectPrice" :starData="starData"  v-show="starData.show" ></Star>
    <roomAndPerson @select="rpData.select" v-show="rpData.show" :rpData="rpData" ></roomAndPerson>
    <submitPage v-if="showSubmitPage" @modifyShowSubmitPage="modifyShowSubmitPage"></submitPage>

    </div>
</template>
<script>
    require('vue-swipe/dist/vue-swipe.css');
    // in CommonJS
    const { Swipe, SwipeItem } = require('vue-swipe');

    import DatePicker from './common/cmpnt/datePicker/datePicker.vue'//日期选择器
    import City from './common/cmpnt/city.vue'//城市选择器
    import HotPlace from './common/cmpnt/hotPlace.vue'//热门地点，商圈选择
    import Star from './common/cmpnt/star.vue'//价格星级选择
    import roomAndPerson from './common/cmpnt/roomAndPerson.vue'//酒店房间和入住人数
    import selectPage from './common/cmpnt/selectPage.vue'//选择项页面

    import activityList from './activity/list.vue'
    import packageList from './free/list.vue'
    import submitPage from './usr/meeting/submitPage.vue'
    import PackageCity from './free/cmpnt/city'//度假热门城市
    import AMapLoader from '@amap/amap-jsapi-loader'
    const HotCityList=require('./common/HomeHotCityHotels.js');//热门城市

	export default{
		name:"index",
		components:{
            SwipeItem,
            Swipe,
            DatePicker,
            City,
            HotPlace,
            Star,
            roomAndPerson,
            activityList,
            packageList,
            selectPage,
            submitPage,
            PackageCity
	 	},
		data(){
			return{
                isAlert:false,
                cityData:{
                    show:false,
                    from:1,
                    myCityName:'深圳',
                    MyCityRegionID:this.MyCityRegionID,

                    select:(city,from)=>{
                        this.cityData.show=false;
                        this.From=from?from:(from==0?0:this.From);
                        this.hotelData.from=from?from:(from==0?0:this.From);

                        this.RegionID=city.I||this.RegionID;
                        this.CityName=city.S||city.N||this.CityName;
                        this.LocationName=city.S||city.N||this.CityName;
                        this.districtId='';
                        this.RegionName='';
                        this.Landmark='';
                        this.LandmarkCode='';
                        this.lmiGruopName='';
                        this.lmiTarget='';

                        if(from==1){
                            this.calendar.last={
                                year:this.getDate(60).split('-')[0],
                                month:this.getDate(60).split('-')[1],
                                day:this.getDate(60).split('-')[2]
                            };
                        }else{
                            this.calendar.last={};
                        }
                        // this.getLandmarkGroups();
                    },
                    reSetLocation:()=>{
                        this.cityData.show=false;
                        this.From=1;
                        this.calendar.last={
                            year:this.getDate(60).split('-')[0],
                            month:this.getDate(60).split('-')[1],
                            day:this.getDate(60).split('-')[2]
                        };

                        // this.getMyposition();
                    }
                },
                packageCityData:{
                    show:false,
                    from:1,
                    PackageID:'2003',
                    PackageCityName:'深圳',
                    select:(city,from)=>{
                        this.packageCityData.show=false;
                        this.packageCityData.PackageID=city.ID||'2003'
                        this.packageCityData.PackageCityName=city.Name||'深圳';
                    },
                    cancel:()=>{
                        this.packageCityData.show=false;
                    }
                },
                hotelData:{
                    show:false,
                    from:1,
                    select:(hotel)=>{

                        if(this.From==1){
                            this.Name=hotel.N;
                        }else{
                            this.foreignName=hotel.N;
                        }
                    },
                    district:(rl)=>{
                        this.Landmark='';
                        this.LandmarkCode='';
                        this.districtId=rl.I;
                        this.RegionName=rl.S||rl.N||rl.E;

                    },

                    landmark:(lm,GruopName)=>{

                        this.hotelData.show=false;
                        this.lmiTarget=lm;
                        this.Landmark=lm.Name;
                        this.Name=lm.hotelName||'';
                        this.lmiGruopName=GruopName||'';
                        this.LandmarkCode=lm.ID||'';
                        this.districtId='';
                        this.RegionName='';

                        this.MyLat=lm.Lat;
                        this.MyLon=lm.Lon;

                        if(this.From==0){
                            this.foreignName=lm.hotelName||'';
                        }

                    }
                },
                starData:{
                    show:false,
                    selectStar:(star,name)=>{
                        this.starData.show=false;
                        this.Star=star;
                        this.StarName=name;
                    },
                    selectPrice:(PriceMin,PriceMax,name)=>{
                        this.starData.show=false;
                        this.PriceName=name;
                        this.PriceMin=PriceMin;
                        this.PriceMax=PriceMax;
                    }
                },

                rpData:{
                    show:false,
                    RoomCount:1,
                    AdultCount:2,
                    ChildrenCount:0,
                    ChildrenAges:'',
                    from:0,
                    select:(val,age)=>{
                        this.rpData.show=false;
                        this.RoomCount=val.RoomCount;
                        this.AdultCount=val.AdultCount;
                        this.ChildrenCount=val.ChildrenCount;

                        var ageList=[];
                        age.forEach((item,index)=>{
                            ageList.push(item.ChildrenAges);
                        })
                        this.ChildrenAges=ageList;

                    }
                },

                calendar:{
                    monthLength:6,
                    show:false,
                    start:{year:this.getDate(0).split('-')[0],month:this.getDate(0).split('-')[1],day:this.getDate(0).split('-')[2]},
                    last:{year:this.getDate(60).split('-')[0],month:this.getDate(60).split('-')[1],day:this.getDate(60).split('-')[2]},
                    begin:{year:this.getDate(0).split('-')[0],month:this.getDate(0).split('-')[1],day:this.getDate(0).split('-')[2]},
                    meetingDate:{year:this.getDate(0).split('-')[0],month:this.getDate(0).split('-')[1],day:this.getDate(0).split('-')[2]},
                    end:{year:this.getDate(1).split('-')[0],month:this.getDate(1).split('-')[1],day:this.getDate(1).split('-')[2]},
                    select:(begin,end)=>{
                        if(this.isDateSelectOneOnly){
                            this.calendar.show=false;
                            this.calendar.meetingDate=begin;
                            this.meetingDate=begin.year+'-'+begin.month+'-'+begin.day;
                        }
                        else{
                            this.calendar.show=false;
                            if(!begin||!end){
                                this.calendar.show=false;
                                return;
                            }
                            this.calendar.begin=begin;
                            this.calendar.end=end;
                            this.CheckIn=begin.year+'-'+begin.month+'-'+begin.day;
                            this.CheckOut=end.year+'-'+end.month+'-'+end.day;
                        }

                    }
                },
                HotCityList:HotCityList.list,
                userInfo:this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'',
                LandmarkGroups:[],
                lmiGruopName:'',
                bannerList:[],
                presaleList:[],
                packageList:[],
                ticketList:[],//门票
                bannerPresaleList:[],
                isHotCityLoading:false,
                productTypeActive:'Hotel',
                cnHotUlActive:true,
                frHotUlActive:true,
                isFollowBefore:true,
                isUserFollowed:false,
                isLoadingPosition:false,
                showPackageRequest:true,

                cnhotCityHotelsList:HotCityList.list[0].value,
                frhotCityHotelsList:HotCityList.list[1].value,
                hotFrom:1,
                CityName:'深圳',
                myCityName:'深圳',
                LocationName:'',
                MyCityRegionID:'',
                RegionName:'',
                PriceMin:'',
                PriceMax:'',
                PriceName:'',
                Landmark:'',
                RegionID:'2003',
                cityId:'2003',
                districtId:'2003',
                ProductType:'1',
                From:1,
                CheckIn:this.getDate(0),
                CheckOut:this.getDate(1),
                Name:'',
                foreignName:'',
                Star:'',
                foreignStar:'',
                StarName:'',
                foreignStarName:'',
                RoomCount:1,
                AdultCount:2,
                ChildrenCount:0,
                ChildrenAges:[5,5],
                lmiTarget:'',
                HotelIDs:'',
                Sort:'',
                MyLat:'',
                MyLon:'',
                MyPositionLat:'',
                MyPositionLon:'',
                Radius:'',
                PackageKeyword:'',//搜索度假关键字
                ticketName:'',//搜索门票关键字
                presaleName:'',//搜索抢购关键字
                frHotCityId:'EAN_178236',
                frHotCityName:'曼谷',
                hotCityId:'3201',
                hotCityName:'香港',
                selectPageType:{'show':false,'type':'活动人数','active':''},
                // 活动人数
                persionNumData:{value:0,lable:'10-30人'},
                // 会议预算
                meetPriceData:{value:0,lable:'3千以下'},
                // 会议类型
                meetTypeData:{value:0,lable:'年会'},
                // 活动城市
                meetCity:{value:'深圳',lable:'深圳'},
                // 活动需求
                meetNeed:{value:0,lable:'开会'},
                // 电话
                phoneNumber:'',
                // 度假类型
                SubType:{value:'',lable:'不限'},
                // 度假目的地
                PackageCity:{value:'',lable:'不限'},
                // 只选择一个日期
                isDateSelectOneOnly:false,
                meetingDate:this.getDate(0),
                // 导航是否固定位置
                FixedLi:false,
                // 是否显示会议 提交完成 页面
                showSubmitPage:false,
                // activeGroups:[
                //     {lable:'全部',value:''},
                //     {lable:'防护用品',value:'2'},
                //     {lable:'生猛海鲜',value:'3'},
                //     {lable:'超值好货',value:'4'},
                //     {lable:'名鸡靓鸭',value:'5'},
                //     {lable:'精美熟食',value:'6'},
                //     {lable:'度假抢购',value:'1'},

                // ],
                // activeGroupsItem:''

			}
        },
		methods:{
            // 活动类目
            // activeGroupsFoo(item){
            //     this.activeGroupsItem=item.value
            //     this.getPresaleList()
            // },
            // 清除 度假 关键字
            clearPackageKeyword($event){
                $event.stopPropagation();
                this.PackageKeyword = ''
            },
            clearTicketKeyword($event){
                $event.stopPropagation();
                this.ticketName = ''
            },
            clearLandmark($event){
                $event.stopPropagation();
                this.Landmark='';
                this.Name='';
                this.LandmarkCode='';
                this.lmiGruopName='';

            },
            clearPriceAndStar($event){
                $event.stopPropagation();
                this.Star='';
                this.StarName='';
                this.PriceName='';
                this.PriceMin='';
                this.PriceMax='';
                this.Landmark='';
                this.LandmarkCode='';
            },
            getMyposition(){
                // var that=this;
                // that.getUserLocation(function(obj){
                //     that.MyLat= obj.latitude||'';
                //     that.MyLon= obj.longitude||'';

                //     //缓存我当前的位置坐标
                //     that.MyPositionLat= obj.latitude||'';
                //     that.MyPositionLon= obj.longitude||'';
                //     // that.getTicketList();
                //     that.getLocation(that.MyLat,that.MyLon);
                // });


                // 百度定位方式
                // var self = this;
                // var geolocation = new BMap.Geolocation();
                // geolocation.getCurrentPosition(function (r) {
                //     console.log(r);
                //         var myGeo = new BMap.Geocoder();
                //         myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (result) {

                //             if (result) {
                //                 self.MyLat = result.point.lat;
                //                 self.MyLon =  result.point.lng;
                //                 self.MyPositionLat = result.point.lat;
                //                 self.MyPositionLon =  result.point.lng;
                //                 // console.log(result)
                //                 // self.cityData.myCityName = result.addressComponents.city;
                //                 self.getLocation(self.MyLat,self.MyLon);
                //             }
                //         });
                // });
                // 高德定位方式
                // AMapLoader.load({
                //     key: 'a244ca850594f15d890ee2d0f93e5508',
                //     version: '2.0',         
                //     plugins: []              
                // }).then(AMap => {
                    
                //     navigator.geolocation.getCurrentPosition(
                //     pos => {
                //         var lng = pos.coords.longitude
                //         var lat = pos.coords.latitude
                //         this.MyLat  = pos.coords.latitude;
                //         this.MyLon  = pos.coords.longitude;
                //         this.MyPositionLat = pos.coords.latitude;
                //         this.MyPositionLon = pos.coords.longitude;
                //         this.getLocation(lng, lat)
                //     },
                //     err => {
                //         console.error('定位失败：' + err.message)
                //     },
                //     { enableHighAccuracy: true, timeout: 10000 }
                //     )
                // }).catch(e => {
                //     console.error('定位失败', e);
                // })
                that.LocationName='';
                that.MyCityRegionID='2003';
                that.cityData.myCityName='深圳';
                that.cityData.MyCityRegionID='2003';
                that.RegionID='2003';
                that.cityId='2003';
                that.districtId='2003';
                that.error({title:'提示',content:'无法定位到具体城市, 请手动选择城市'});
            },
            // getLocation(lng, lat){
            //     var that=this;
            //     that.LocationName='';
            //     that.isLoadingPosition=true;
            //     that.jsonpRequest({
            //         url:'https://restapi.amap.com/v3/geocode/regeo?location='+lng+','+lat+'&key=244ca850594f15d890ee2d0f93e5508',
            //     }).then(res => {
            //         that.isLoadingPosition=false;
            //         if(res&&res.status==1&&res.regeocode.addressComponent&&res.regeocode.addressComponent.city.length>0&&res.regeocode.formatted_address.length>0){
            //             that.CityName=res.regeocode.addressComponent.city||that.CityName;
            //             that.LocationName=res.regeocode.formatted_address||that.LocationName;
            //             var briefCity=that.CityName.slice(0,that.CityName.length-1)
            //             that.meetCity.value=briefCity
            //             that.meetCity.lable=briefCity
            //             // that.cityData.LocationName=res.result.formatted_address||that.LocationName;
            //             that.getLocateCity(that.CityName);
            //         }else{
            //             this.error({title:'提示',content:'定位失败，请手动选择城市'});
            //             this.cityData.show=true;
            //         }
            //     });
            // },
            // getLocateCity(CityName){
            //     var that=this;
            //     var params={
            //         city:CityName,
            //     }
            //     that.getRequest({
            //         url: this.Api.getLocateCity,
            //         params: params
            //     }).then(res => {
            //         if(res){
            //             that.MyCityRegionID=res;
            //             that.cityData.myCityName=CityName;
            //             that.cityData.MyCityRegionID=res;
            //             that.RegionID=res;
            //             that.cityId=res;
            //             that.districtId=res;
            //             // that.getLandmarkGroups();
            //             // that.getxyLocation();
            //         }else{
            //             that.LocationName='';
            //             that.MyCityRegionID='2003';
            //             that.cityData.myCityName='深圳';
            //             that.cityData.MyCityRegionID='2003';
            //             that.RegionID='2003';
            //             that.cityId='2003';
            //             that.districtId='2003';
            //             that.error({title:'提示',content:'无法定位到具体城市, 请手动选择城市'});
            //         }
            //         that.dao.set('MyCityID',that.MyCityRegionID)
            //         that.dao.set('MyCityName',CityName)
            //     });
            // },
            // getHotCityHotels(){
            //     var that=this;

            //     that.getRequest({
            //         url: this.Api.getHotCityHotels,

            //     }).then(res => {
            //         if(res){
            //             this.cnhotCityHotelsList=res[0].value;
            //             this.frhotCityHotelsList=res[1].value;
            //             this.getHotCityHotelsInfoList(this.cnhotCityHotelsList[0],1);
            //             this.getHotCityHotelsInfoList(this.frhotCityHotelsList[0],0);
            //         }
            //     });
            // },
            //获取预售列表
            // getPresaleList(){
            //     var that=this;
            //     var params={
            //         Page:1,
            //         PageSize:5,
            //         Str:this.presaleName
            //         // Category:this.activeGroupsItem
            //     }
            //     that.postRequest({
            //         url: that.Api.getPreSaleList,
            //         params: params
            //     }).then(res => {
            //         if (res&&res.IsSuccess&&res.Result.length>0) {
            //             that.presaleList=res.Result;
            //             that.initClock(res.Result);
            //         } else {
            //             that.presaleList='';
            //         }
            //     });
            // },
            /**
             * BannerType==1 酒店
             * BannerType==2 度假
             * BannerType==3 预售
             */
            // 打开详情
            // toPresaleDetail(id,img){
            //     if(img.Url){
            //         // window.location.href=img.Url;
            //         // return;
            //         if(img.BannerType==1){
            //             var hotelId=img.ProductID;
            //             var hotelFrom=img.ProductID>=5000000?0:1;
            //             var obj={
            //                 ID:hotelId,
            //             }
            //             this.routeToDetails(obj,hotelFrom)
            //         }else if(img.BannerType==2){
            //             this.$router.push("/packageDetails?id="+img.ProductID+"&price=''");
            //         }else if(img.BannerType==3){
            //             this.$router.push('/presaleDetails?id='+img.ProductID);
            //         }else {
            //             window.location.href=img.Url;
            //         }
            //     }
                

            // },
            //获取门票列表
            // getTicketList(){
            //     var that=this;
            //     var params={
            //         CityID:that.MyCityRegionID||that.RegionID,
            //         Type:1,
            //         Page:1,
            //         PageSize:5,
            //     }
            //     that.postRequest({
            //         url: that.Api.getOnlineList,
            //         params: params
            //     }).then(res => {
            //         if (res&&res.IsSuccess&&res.Result.length>0) {
            //             that.ticketList=res.Result;
            //             // that.getTicketRange(res.Result);
            //         } else {
            //             that.ticketList='';
            //         }
            //     });
            // },
            //查看门票详情
            // toTicketDetails(ticket){
            //     this.$router.push('/ticketDetails?id='+ticket.ScenicId);
            // },


            //获取自由行列表
            getPackageList(){
                var that=this;
                var params={
                    CustomerNO:'BJ100138',
                    CityID:that.packageCityData.PackageID,
                    Type:0,
                    Page:1,
                    PageSize:5,
                    IsFromPC:false
                }
                that.postRequest({
                    url: that.Api.getOnlinePackageList,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess&&res.Result.length>0) {
                        that.packageList=res.Result;
                        that.initClock(res.Result);
                    } else {
                        that.packageList='';
                    }
                });
            },
            initClock(list) {
                for (var i = 0; i < list.length; i++) {
                    this.timeLoop(list[i], list[i].SaleStart, list[i].SaleEnd);
                }
            },
            timeLoop(item, start, end) {
                var num = 1;
                var that = this;
                var end = that.dateIntervene(end);
                var start = that.dateIntervene(start);
                var time = setInterval(function() {
                    num++;
                    if (num >= end) {
                    clearInterval(time);
                    } else {
                        var hour = that.betDateH(end - num)
                        that.$nextTick(function() {
                            if(start>0){
                                that.$set(item, "clockStart", that.betDateFomate(start - num));
                            }else if(start<=0&&hour<48){
                                that.$set(item, "clockHour", hour);
                                that.$set(item, "clockEnd", that.betDateFomate(end - num));
                            }
                        });
                    }
                }, 1000);
            },
            dateIntervene(date) {
                var s1 = new Date().getTime();
                var s2 = new Date(date).getTime();
                return parseInt((s2 - s1 > 0 ? s2 - s1 : 0) / 1000);
            },
            betDateH(time){
                return Math.floor((time / 60 / 60));
            },
            betDateFomate(time) {
                var d, h, m, s;
                if (time >= 0) {
                    d = Math.floor(time / 60 / 60 / 24);
                    h = Math.floor((time / 60 / 60) % 24);
                    m = Math.floor((time / 60) % 60);
                    s = Math.floor(time % 60);
                }

                var intv =
                    "<span>" +
                    d +
                    "</span> 天 <span>" +
                    (h < 10 ? "0" + h : h) +
                    "</span> : <span>" +
                    (m < 10 ? "0" + m : m) +
                    "</span> : <span>" +
                    (s < 10 ? "0" + s : s)

                return intv;
            },
            // getRange(list){
            //     var that = this;
            //     var params = {
            //         CheckIn: new Date(),
            //         HotelIDs: that.getHotelIdArr(list)
            //     }
            //     that.postRequest({
            //         url: that.Api.getPriceRange,
            //         params: params
            //     }).then(res => {
            //         if (res&&res.IsSuccess&&res.Result.length>0) {
            //             that.packageList = that.concatList(list,res.Result);
            //         }
            //     });
            // },
            // getHotelIdArr(list){
            //     var arr = [];
            //     for(let i = 0; i < list.length; i++){
            //         arr.push(list[i].HotelID)
            //     }
            //     return arr
            // },
            // concatList(list,HotelIDList){
            //     var list = list;
            //     for(let i = 0; i < list.length; i++){
            //         for(let j = 0; j < HotelIDList.length; j++){
            //             if(list[i].HotelID == HotelIDList[j].HotelID){
            //                 list[i].Min = HotelIDList[j].Min;
            //                 list[i].Max = HotelIDList[j].Max;
            //             }
            //         }
            //     }
            //     return list;
            // },
            getHotCityHotelsInfoList(item,from){
                var that=this;
                if(from==1){
                    this.hotCityId = item.id
                    this.hotCityName = item.key
                    that.$nextTick(function () {
                        for(var i=0;i<that.cnhotCityHotelsList.length;i++){
                            that.cnhotCityHotelsList[i].active=false;
                        }
                        that.$set(item,'active',item.active?false:true);
                    });
                }else{
                    this.frHotCityId = item.id
                    this.frHotCityName = item.key
                    that.$nextTick(function () {
                        for(var i=0;i<that.frhotCityHotelsList.length;i++){
                            that.frhotCityHotelsList[i].active=false;
                        }
                        that.$set(item,'active',item.active?false:true);
                    });

                }

                //判断是否已经加载过，是则不再请求
                // if(item.list&&item.list.length>0)return;
                that.isHotCityLoading=true;

                var params={
                    RegionID:'',
                    From:from,
                    ProductType:0,
                    Name:'',
                    Landmark:'',
                    Star:'',
                    PriceMin:'',
                    PriceMax:'',
                    CheckIn:that.CheckIn,
                    CheckOut:that.CheckOut,
                    RoomCount:1,
                    AdultCount:2,
                    ChildrenCount:0,
                    ChildrenAges:[5,5],
                    Page:1,
                    PageSize:10,
                    HotelIDs:item.value,
                    Sort:0,
                    MyLat:that.MyLat||'',
                    MyLon:that.MyLon||'',
                    Radius:'',
                    MyCityRegionID:that.MyCityRegionID||'',
                }
                that.postRequest({
                    url: that.Api.price,
                    params: params
                }).then(res => {
                    that.isHotCityLoading=false;
                    if (res&&res.IsSuccess&&res.Result.length>0) {
                        that.$nextTick(function () {
                            that.$set(item,'list',res.Result);
                        });
                    }
                });

            },
           //保存到历史记录
            saveHotelToHistory(hotel,from){

                var list=this.dao.get('hotelViewHistory')?JSON.parse(this.dao.get('hotelViewHistory')):[];

                if(list&&list.length>0){
                    list.forEach((item,index)=>{
                        if(item.ID==hotel.ID){
                            list.splice(index,1)
                        }

                    })
                    hotel['From']=from;
                    hotel['date']=new Date();
                    list.unshift(hotel)


                }else{
                    hotel['From']=from;
                    hotel['date']=new Date();
                    list.unshift(hotel)
                }
                this.dao.set('hotelViewHistory',JSON.stringify(list));

            },
            //进入酒店详情页
            routeToDetails(item,from){
                var obj={
                    HotelID:item.ID,
                    ProductType:0,
                    From:from,
                    CheckIn:this.CheckIn,
                    CheckOut:this.CheckOut,
                    RoomCount:this.RoomCount,
                    AdultCount:this.AdultCount,
                    ChildrenCount:this.ChildrenCount,
                    ChildrenAges:this.ChildrenAges,
                    MyCityRegionID:this.MyCityRegionID,
                }
                if(from==1){
                     this.dao.set('hotelDetailsParams',JSON.stringify(obj));

                    //保存到历史记录
                    this.saveHotelToHistory(item,from);

                    this.$router.push('/hotelDetails');
                }else{
                    this.dao.set('frHotelDetailsParams',JSON.stringify(obj));

                    //保存到历史记录
                    this.saveHotelToHistory(item,from);

                    this.$router.push('/frHotelDetails');

                }
            },

            getLandmarkGroups(){
                var that=this;
                that.dao.set('LandmarkGroups',[]);

                var params={
                    isCN:that.From==1?true:false,
                    pid:that.RegionID,
                    q:'',
                    group:'',
                    pageSize:13,
                }
                that.getRequest({
                    url: that.Api.getLandmarkGroups,
                    params: params
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.LandmarkGroups=res.Result;
                        that.dao.set('LandmarkGroups',JSON.stringify(res.Result));
                    }
                });
            },
            getBannerList(){
                var that=this;
                that.getRequest({
                    url: that.Api.banner
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.bannerList=res.Result;
                    }
                });
            },
            routeToTicketList(){
                var that=this;
                this.$router.push('/ticketList?CityID='+that.RegionID+'&CityName='+that.CityName+'&key='+that.ticketName);
            },
            routeToPackageList(){
                var that=this;
                this.$router.push('/packageList?CityID='+that.packageCityData.PackageID+'&CityName='+that.packageCityData.PackageCityName+'&Name='+that.PackageKeyword);
            },
            routerToHotel(img){
                if(img.Url){
                    // window.location.href=img.Url;
                    // return;
                    if(img.BannerType==1){
                        var hotelId=img.ProductID;
                        var hotelFrom=img.ProductID>=5000000?0:1;
                        var obj={
                            ID:hotelId,
                        }
                        this.routeToDetails(obj,hotelFrom)
                    }else if(img.BannerType==2){
                        this.$router.push("/packageDetails?id="+img.ProductID+"&price=''");
                    }else if(img.BannerType==3){
                    this.$router.push('/presaleDetails?id='+img.ProductID);
                    }else{
                        window.location.href=img.Url;
                    }
                }
            },
            submit(item){
                var today=this.getDate(0);
                var days=this.getDays(today,this.CheckOut);
                if(days>60){
                    this.error({title:'提示',content:'国内及港澳酒店日历只能选60天内，请重新选择!'});
                    return;
                }
                var obj={
                    RegionID:item=='more'?this.hotCityId:this.RegionID,
                    CityName:item=='more'?this.hotCityName:this.CityName,
                    StarName:this.StarName,
                    districtId:item=='more'?this.hotCityId:this.districtId,
                    MyCityRegionID:this.MyCityRegionID||'',
                    From:1,
                    ProductType:0,
                    Name:this.Name,
                    lmiGruopName:this.lmiGruopName,
                    Landmark:this.Landmark,
                    LandmarkCode:this.LandmarkCode||'',
                    Star:this.Star,
                    PriceMin:this.PriceMin,
                    PriceMax:this.PriceMax,
                    PriceName:this.PriceName,
                    CheckIn:this.CheckIn,
                    CheckOut:this.CheckOut,
                    RoomCount:this.RoomCount,
                    AdultCount:this.AdultCount,
                    ChildrenCount:this.ChildrenCount,
                    ChildrenAges:this.ChildrenAges,
                    Page:1,
                    PageSize:10,
                    FilterNOPrice:false,
                    SupID:'',
                    HotelIDs:'',
                    Sort:0,
                    MyLat:this.MyLat||'',
                    MyLon:this.MyLon||'',
                    MyPositionLat:this.MyPositionLat||'',
                    MyPositionLon:this.MyPositionLon||'',
                    Radius:'',
                    lmiTarget:this.lmiTarget,
                }
                this.dao.set('hotelListSearchParams',JSON.stringify(obj));

                this.$router.push('/hotelList');
            },
            dateIntervene(date){
                var s1=new Date().getTime();
                var s2=new Date(date).getTime();
                return parseInt(((s2-s1>0)?(s2-s1):0)/1000);
            },
            frSubmit(item){
                var obj={
                    RegionID:item=='more'?this.frHotCityId:this.RegionID,
                    CityName:item=='more'?this.frHotCityName:this.CityName,
                    StarName:this.Star,
                    districtId:item=='more'?this.frHotCityId:this.districtId,
                    MyCityRegionID:this.MyCityRegionID||'',
                    From:0,
                    ProductType:0,
                    Name:this.foreignName,
                    lmiGruopName:this.lmiGruopName,
                    Landmark:this.Landmark,
                    LandmarkCode:this.LandmarkCode||'',
                    Star:this.Star,
                    PriceMin:this.PriceMin,
                    PriceMax:this.PriceMax,
                    PriceName:this.PriceName,
                    CheckIn:this.CheckIn,
                    CheckOut:this.CheckOut,
                    RoomCount:this.RoomCount,
                    AdultCount:this.AdultCount,
                    ChildrenCount:this.ChildrenCount,
                    ChildrenAges:this.ChildrenAges,
                    Page:1,
                    PageSize:10,
                    FilterNOPrice:false,
                    SupID:'',
                    HotelIDs:'',
                    Sort:0,
                    MyLat:this.MyLat||'',
                    MyLon:this.MyLon||'',
                    Radius:'',
                }

                this.dao.set('frHotelListSearchParams',JSON.stringify(obj))
                this.$router.push('/frHotelList');

            },
            getxyLocation() {
                if (navigator.geolocation){
                    navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
                }else{
                    x.innerHTML="Geolocation is not supported by this browser.";
                }
            },
            showPosition(position){
                this.MyLat= position.coords.latitude;
                this.MyLon= position.coords.longitude;
            },
            alert(){
                this.error({title:'提示',content:'敬请期待!'});
            },
            showError(){
                // alert('定位出错')
            },
            // 获取账号是否已经关注了公众号
            isUserFollow(){
                var that=this;
                that.getRequest({
                    url: this.Api.getIsSubscribed
                }).then(res => {
                    if(res&&!res.Result){
                        this.isUserFollowed=true;
                    }
                });
            },
            alertPresale(){
                this.error({title:'提示',content:'敬请期待!'});
            },
            toFollow(){
                window.location.href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1NDEyMjkwNw==&scene=124&#wechat_redirect";
            },
            //获取抢购广告轮播图
            getBannerSmallImgList(){
                var that=this;
                that.getRequest({
                    url: that.Api.bannerPresale
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.bannerPresaleList=res.Result;
                    }
                });

            },
            // 显示-隐藏 选项页
            controlSelectPage(bool,type,active){
                this.selectPageType.show = bool
                if(type){
                    this.selectPageType.type = type
                    this.selectPageType.active=active
                }
            },
            // 获得选项信息
            getSelectData(item,type){
                if(type=='活动人数'){
                    this.persionNumData = item
                }
                else if(type=='活动预算'){
                    this.meetPriceData = item
                }
                else if(type=='活动类型'){
                    this.meetTypeData = item
                }
                else if(type=='活动城市'){
                    this.meetCity = item
                }
                else if(type=='活动需求'){
                    this.meetNeed = item
                }
                else if(type=='选择目的地'){
                    this.PackageCity = item
                }
                else if(type=='类型'){
                    this.SubType = item

                }
            },
            dateSelect(){
                this.isDateSelectOneOnly = false
                this.calendar.show=true

            },
            meetTime(){
                this.isDateSelectOneOnly = true
                this.calendar.show=true
            },
            modifyShowSubmitPage(item){
                this.showSubmitPage = item
            },
            meetingQueryVerify(){
                if(!this.meetCity.value){
                    this.error({title:'提示',content:'请选择活动城市！'});
		 	 		return;
                }
                else if(!this.persionNumData.value && this.persionNumData.value !==0){
                    this.error({title:'提示',content:'请选择参与人数！'});
		 	 		return;
                }
                else if(!this.meetPriceData.value && this.meetPriceData.value !==0){
                    this.error({title:'提示',content:'请选择活动预算！'});
		 	 		return;
                }
                else if(!this.meetTypeData.value && this.meetTypeData.value !==0){
                    this.error({title:'提示',content:'请选择活动类型！'});
		 	 		return;
                }
                else if(!this.meetNeed.value && this.meetNeed.value !==0){
                    this.error({title:'提示',content:'请选择活动需求！'});
		 	 		return;
                }
                else if(!this.phoneNumber){
                    this.error({title:'提示',content:'请输入号码！'});
		 	 		return;
                }
                else if(!this.checkMobile(this.phoneNumber)){
                    return;
                }
                else{
                    this.meetingQuery()
                }
            },
            meetingQuery(){
                var params={
                    // MettingID:'',//会议需求编号
                    MettingVenue:this.meetCity.value,//活动城市
                    MettingType:this.meetTypeData.value,
                    HoldingTime:this.meetingDate,
                    NumberOfPeople:this.persionNumData.value,//参加人数
                    Budget:this.meetPriceData.value,//预算
                    ProjectServices:this.meetNeed.value,//会议需求
                    PhoneNumber:this.phoneNumber,
                    // Name:'',//姓名
                }
                this.postRequest({
                    url: this.Api.MeetingCreate,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess) {
                        // this.defaultMeeting()
                        this.modifyShowSubmitPage(true)
                    }else{
                        this.error({title:'提示',content:res.Msg});
                    }
                });
            },
            defaultMeeting(){
                this.meetCity={value:'香港',lable:'香港'},
                this.meetTypeData={value:'',lable:''};
                this.persionNumData={value:'',lable:''};
                this.meetPriceData={value:'',lable:''};
                this.meetNeed={value:'',lable:''};
                this.phoneNumber='';
            },
            // 设置标题行的随屏滚动位置监听
            initWindowScrollEventListener() {

                var that = this;
                var windowSrollTop=0;//屏幕滚动高度
                var fixLiHeight=0;//标题栏的高度位置

                window.addEventListener('touchstart', touchScroll);
                window.addEventListener('touchmove',touchScroll);
                window.addEventListener('touchend',touchScroll);
                window.addEventListener('scroll',touchScroll);

                function touchScroll(){
                  if(that.$refs['lmy-home-page']) {

                    windowSrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
                    fixLiHeight = fixLiHeight || that.$refs['fixLi'].offsetTop;

                    that.FixedLi = (windowSrollTop > fixLiHeight) ? true : false;
                  }
                }
            },
            getHotCity(){
                var that = this
                that.getRequest({
                    url: that.Api.getPackageHotCity,
                    })
                    .then(res => {
                        if(res&&res.IsSuccess){
                            that.dao.set('getPackageHotCity',JSON.stringify(res.Result));
                        }
                    });
            },

        },
        beforeRouteEnter: (to, from, next) => {
            if(from.path=='/anonymLogin'){
                next(vm=>{
                    vm.$router.go(0);
                })
            }else{
                next()
            }
        },
        created(){
            this.getHotCity()
        },
        mounted(){
            this.$root.myImg=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')).Avater:'';
            // 获取账号是否已经关注了公众号
            // this.isUserFollow();
            // 加载小banner
            this.getBannerSmallImgList();
            //先加载热门城市
            this.getHotCityHotelsInfoList(this.cnhotCityHotelsList[0],1);
            this.getHotCityHotelsInfoList(this.frhotCityHotelsList[0],0);

            // this.getMyposition();
            this.getBannerList();
            // this.getPresaleList();
            this.getPackageList();
            // this.getTicketList();//获取门票
            this.dao.set('LandmarkGroups','');
            this.initWindowScrollEventListener();


        },
        activated(){
            this.userInfo=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'';
        },


	}

</script>




// WEBPACK FOOTER //
// src/components/index.vue